var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronRight = function SvgIconChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.318.655a.516.516 0 0 1 .69.036L5.93 3.61a.518.518 0 0 1 .001.73L3.007 7.263a.517.517 0 0 1-.73-.73l2.557-2.557L2.279 1.42a.515.515 0 0 1-.036-.69L2.28.69l.039-.035z"
  })));
};
export default SvgIconChevronRight;